<template>
    <div class="popupContainer">
        <div class="InfoList">
            <div class="inputLabelTop">{{ $t('withdraw.method') }}</div>
            <div class="tabList">
                <div class="tab_card" v-for="item in TAB_TYPE_LIST" :key="item.id"
                    :class="activeTab.id == item.id ? 'active_tab' : ''" @click="selectTabType(item)">
                    {{ item.name }}
                </div>
            </div>
            
            <div class="input_container_name">
                <div class="custom_label">{{ $t('withdraw.name') }}</div>
                <van-field v-model="userName"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.userName != null && withdrawStore.withdrawInfo.userName != ''"
                     :placeholder="$t('withdraw.userNamePlaceholder')">
                    <!-- <template #left-icon>
                        <div class="inputLabel">{{ $t('withdraw.name') }}</div>
                    </template> -->
                </van-field>
            </div>
 
            <div class="input_container" v-if="activeTab.id == 1" :class="{ 'has-error': showCPFIdError && cpfIDTouched }">
                <div class="custom_label">CPF ID</div>
                <van-field v-model="cpfID" type="number"
                    @update:modelValue="cpfIDTouched = true"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.cpf != null && withdrawStore.withdrawInfo.cpf != ''"
                    :placeholder="$t('withdraw.cpfIdPlaceholder')" :border="false">
                    <!-- <template #left-icon>
                        <div class="inputLabel">CPF ID</div>
                    </template> -->
                     <template #left-icon>
                      <div class="left-wrapper">
                         <img src="@/assets/themeFour/CPF.png" alt="CPF" class="cpf-icon" />
                      </div>
                    </template>
                </van-field>
            </div>
            <div class="input_container" v-if="activeTab.id == 2" :class="{ 'has-error': showEmaiIdError && emailIDTouched }">
                <div class="custom_label">Email ID</div>
                <van-field v-model="emailID"
                    @update:modelValue="emailIDTouched = true"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.email != null && withdrawStore.withdrawInfo.email != ''"
                    :placeholder="$t('withdraw.emailPlaceholder')">
                    <!-- <template #left-icon>
                        <div class="inputLabel">Email ID</div>
                    </template> -->
                </van-field>
            </div>
            <div class="input_container" v-if="activeTab.id == 3" :class="{ 'has-error': showPhoneIdError && phoneIDTouched }">
                <div class="custom_label">PHONE ID</div>
                <van-field v-model="phoneID" type="number"
                    @update:modelValue="phoneIDTouched = true"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.phone != null && withdrawStore.withdrawInfo.phone != ''"
                     :placeholder="$t('withdraw.phonePlaceholder')">
                    <!-- <template #left-icon>
                        <div class="inputLabel">PHONE ID</div>
                    </template> -->
                    <template #left-icon>
                        <div class="leftContainer" >
                        <img src="@/assets/loginRegister/br_flag.png" alt="" />
                        <p class="currencyText">+55</p>
                        <div class="line"></div>
                        </div>
                        </template>
                </van-field>
            </div>
            <div class="input_container" v-if="activeTab.id == 4" :class="{ 'has-error': showEvpIdError && evpIDTouched }">
                <div class="custom_label">EVP</div>
                <van-field v-model="evpID" 
                    @update:modelValue="evpIDTouched = true"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.evpId != null && withdrawStore.withdrawInfo.evpId != ''"
                    :placeholder="$t('withdraw.evpPlaceholder')">
                    <!-- <template #left-icon>
                        <div class="inputLabel">EVP</div>
                    </template> -->
                </van-field>
            </div>
            <div class="errorText" v-if="activeTab.id == 1 && showCPFIdError
                || activeTab.id == 2 && showEmaiIdError
                || activeTab.id == 3 && showPhoneIdError
                || activeTab.id == 4 && showEvpIdError">
                {{
                    t(activeTab.errorText) }}</div>

            <div class="input_container" :class="{ 'has-error': showCPFNumError && cpfNumberTouched }">
                <div class="custom_label">CPF</div>
                <van-field v-model="cpfNumber" type="number"
                    @update:modelValue="cpfNumberTouched = true"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.cpfId != null && withdrawStore.withdrawInfo.cpfId != ''"
                     :placeholder="$t('withdraw.userNamePlaceholder')">
                    <!-- <template #left-icon>
                        <div class="inputLabel">CPF</div>
                    </template> -->
                </van-field>
            </div>
            <div v-if="showCPFNumError" class="errorText">{{ $t("withdraw.cpfErrorText") }}</div>

            <div class="input_container" v-if="dataSetTwo?.selectedChannel.channelType == '7'">
                <div class="custom_label">{{ $t("withdraw.brazilId") }}</div>
                <van-field v-model="brazilID"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.brazilId != null && withdrawStore.withdrawInfo.brazilId != ''"
                    type="number"  :placeholder="$t('withdraw.brazilIdPlaceholder')">
                    <!-- <template #right-icon>
                        <div class="inputLabel">{{ $t("withdraw.brazilId") }}</div>
                    </template> -->
                </van-field>
            </div>
            <div class="input_container" v-if="withdrawStore.selectedChannel.channelType == '1'">
                <div class="custom_label">{{ $t("withdraw.bankName") }}</div>
                <van-field v-model="bank"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.bank != null && withdrawStore.withdrawInfo.bank != ''"
                    type="text"  :placeholder="$t('withdraw.bankPlaceholder')">
                    <!-- <template #left-icon>
                        <div class="inputLabel">{{ $t("withdraw.bankName") }}</div>
                    </template> -->
                </van-field>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { nextTick } from 'vue'
import { TAB_TYPE_LIST, WithdrawPopupData } from '@/view/withdraw/supportScript';
import { useWithdrawStore } from '@/stores/withdraw';
const { t } = useI18n();


const props = defineProps<{
    dataSetTwo: WithdrawPopupData
}>()

const withdrawStore = useWithdrawStore()
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref(props.dataSetTwo.cpfID)
const emailID = ref(props.dataSetTwo.emailID)
const phoneID = ref(props.dataSetTwo.phoneID)
const evpID = ref(props.dataSetTwo.evpID)
const userName = ref(props.dataSetTwo.userName)
const cpfNumber = ref(props.dataSetTwo.cpfNumber)
const brazilID = ref(props.dataSetTwo.brazilID)
const bank = ref(props.dataSetTwo.bank)
const showCPFIdError = ref(props.dataSetTwo.showCPFIdError)
const showEmaiIdError = ref(props.dataSetTwo.showEmaiIdError)
const showPhoneIdError = ref(props.dataSetTwo.showPhoneIdError)
const showEvpIdError = ref(props.dataSetTwo.showEvpIdError)
const showCPFNumError = ref(props.dataSetTwo.showCPFNumError)
const cpfIDTouched = ref(false)
const emailIDTouched = ref(false)
const phoneIDTouched = ref(false)
const evpIDTouched = ref(false)
const cpfNumberTouched = ref(false)
const activeButton = ref(false)

const emits = defineEmits(['close', 'open', 'selectTabType', 'confirmWithdrawPopup', 'updateFormValues', 'changeValue', 'checkFieldsFill'])

const open = (amount: number, data: any) => {
    emits('open')
}
const close = () => {
    emits('close')
}

const selectTabType = (item: any) => {
    activeTab.value = item
    emits('selectTabType', item)
}

const confirmWithdraw = () => {
    emitFormValues()
    emits('confirmWithdrawPopup')
}

const emitFormValues = () => {
    emits('updateFormValues', {
        cpfID: cpfID.value,
        emailID: emailID.value,
        phoneID: phoneID.value,
        evpID: evpID.value,
        userName: userName.value,
        cpfNumber: cpfNumber.value,
        brazilID: brazilID.value,
        bank: bank.value,
        activeTab: props.dataSetTwo.activeTab,
    })
}

watch(() => props.dataSetTwo, (newVal) => {
    if (cpfID.value !== newVal.cpfID) cpfID.value = newVal.cpfID
    if (emailID.value !== newVal.emailID) emailID.value = newVal.emailID
    if (phoneID.value !== newVal.phoneID) phoneID.value = newVal.phoneID
    if (evpID.value !== newVal.evpID) evpID.value = newVal.evpID
    if (userName.value !== newVal.userName) userName.value = newVal.userName
    if (cpfNumber.value !== newVal.cpfNumber) cpfNumber.value = newVal.cpfNumber
    if (brazilID.value !== newVal.brazilID) brazilID.value = newVal.brazilID
    if (bank.value !== newVal.bank) bank.value = newVal.bank
}, { deep: true })


watch(cpfID, (val) => {
    if (val.length == 11) {
        showCPFIdError.value = false
    } else {
        showCPFIdError.value = true
    }
    let data = {
        type: 'cpfID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(emailID, (val) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(val)) {
        showEmaiIdError.value = false
    } else {
        showEmaiIdError.value = true
    }
    let data = {
        type: 'emailID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(phoneID, (val) => {
    if (val.length == 11) {
        showPhoneIdError.value = false
    } else {
        showPhoneIdError.value = true
    }
    let data = {
        type: 'phoneID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(evpID, (val) => {
    if (val.length > 0) {
        showEvpIdError.value = false
    } else {
        showEvpIdError.value = true
    }
    let data = {
        type: 'evpID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(cpfNumber, (val) => {
    if (val.length == 11 || val.length == 0) {
        showCPFNumError.value = false
    } else {
        showCPFNumError.value = true
    }
    let data = {
        type: 'cpfNumber',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(userName, (val) => {
    let data = {
        type: 'userName',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(brazilID, (val) => {
    let data = {
        type: 'brazilID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(bank, (val) => {
    let data = {
        type: 'bank',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})

watch(activeTab, () => {
  cpfIDTouched.value = false
  emailIDTouched.value = false
  phoneIDTouched.value = false
  evpIDTouched.value = false
  cpfNumberTouched.value = false
  checkFieldsFill()
})

const checkFieldsFill = () => {
    const activeId = activeTab.value.id 
    if (activeId === 1) {
        activeButton.value = (cpfID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showCPFIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 2) {
        activeButton.value = (emailID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEmaiIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 3) {
        activeButton.value = (phoneID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showPhoneIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 4) {
        activeButton.value = (evpID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEvpIdError.value &&
            !showCPFNumError.value
    }
    emits('checkFieldsFill', activeButton.value)
}


defineExpose({
    open,
    close,
    confirmWithdraw,
})

</script>
<style scoped>
/* 1. Containers */
.popupContainer {
  width: 100%;
  padding: 10px 0;
  overflow-y: auto;
  border-radius: 10px;
  margin-top: 10px;
}

.InfoList {
  padding: 0 16px;
}

.input_container {
  position: relative;
  margin-top: 18px;
}

.input_container_name {
  position: relative;
  margin-top: 18px;
}

.input_container_name:focus-within :deep(.van-field) {
  border: 1.5px solid #0db0ae; 
}

.input_container:focus-within :deep(.van-field) {
  border: 1.5px solid #0db0ae; 
}

.input_container.has-error:focus-within :deep(.van-field) {
  border: 1.5px solid red;
}

/* 2. Tabs */
.tabList {
  display: flex;
  overflow-x: auto;
  padding: 10px 5px;
  gap: 10px;
}
.tabList::-webkit-scrollbar { display: none; }

.tab_card {
  border-radius: 8px;
  min-width: 70px;
  color: rgba(255, 255, 255, .4);
  background-color: rgb(2, 74, 73);
  text-align: center;
  padding: 10px;
  font-size: 15px;
}

.active_tab {
  font-weight: bold;
  border: 1px solid rgb(13, 176, 174);
  background-image: linear-gradient(180deg, transparent 16.59%, rgba(58, 140, 227, .4) 110.34%), #1A1F30;
  color: rgb(13, 176, 174);
}

.inputLabelTop {
  color: #FFF;
  font-size: 16px;
  font-weight: bold;
}

.custom_label {
  color: #668685;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 600;
}

:deep(.van-field) {
  background: #002121 !important;
  border: 1px solid rgb(0, 97, 95);
  padding: 5px 10px !important;
  margin-top: 5px;
  border-radius: 8px;
  align-items: center;
}

:deep(.van-field__control) {
  font-size: 18px !important;
  color: #FFF !important;
  font-weight: 600;
  padding: 10px 5px;
}

:deep(.van-field__control::placeholder) {
  color: #ffffff40 !important;
  font-size: 16px !important;
}

:deep(.van-field__control:disabled) {
  color: #FFF !important;
  -webkit-text-fill-color: #FFF !important;
  opacity: 1;
}

.input_container_name::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: rgb(13, 176, 174);
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.input_container_name:focus-within::after { width: 100%; }

.errorText {
  color: red;
  margin: 5px;
  font-size: 15px;
}

.left-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    /* padding-right: 10px; */
    height: 25px;
    margin-left: 5px;
}

.cpf-icon {
    width: 20px;
    height: 100%;
}

.leftContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.currencyText {
  color: #fff;
    padding: 0 5px;
    margin: 0;
    font-size: 18px;
}

.leftContainer img {
  width: 25px;
}

.line {
  width: 3px;
  background-color: rgb(0, 97, 95);
  height: 20px;
  margin-right: 5px;
}

@media (max-width: 360px) {
  .InfoList {
    padding: 0 15px;
  }

  .inputLabelTop {
    font-size: 14px;
  }

  .tab_card {
    font-size: 13px;
    padding: 10px;
    min-width: 60px;
  }

  .input_container {
    margin-top: 14px;
    padding: 0px 0px;
  }

  .custom_label {
    font-size: 12px;
    margin-bottom: 6px;
  }

  .input_container :deep(.van-field__control) {
    font-size: 15px !important;
  }

  .input_container :deep(.van-field__control::placeholder) {
    font-size: 15px !important;
  }

  .errorText {
    font-size: 12px;
    margin: 4px;
  }

  .currencyText {
    padding: 0 5px;
    margin: 0;
    font-size: 16px;
  }

  .left-wrapper {
    height: 20px;
  }

  .cpf-icon {
    width: 15px;
    height: 100%;
   }
}

</style>